var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field",class:typeof _vm.classes.wrapper != 'undefined' ? _vm.classes.wrapper : {}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"field__inner"},[_vm._t("input")],2),_vm._v(" "),(_vm.error != '')?_c('div',{staticClass:"field__error",domProps:{"innerHTML":_vm._s(_vm.error)}}):_vm._e(),_vm._v(" "),_vm._t("extra")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c82e1d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/Field.vue
// module id = null
// module chunks = 